import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.notification.fields.id'),
  },
  {
    name: 'title',
    label: i18n('entities.notification.fields.title'),
  },
  {
    name: 'subject',
    label: i18n('entities.notification.fields.subject'),
  },
  {
    name: 'body',
    label: i18n('entities.notification.fields.body'),
  },
  {
    name: 'status',
    label: i18n('entities.notification.fields.status'),
  },
  {
    name: 'from',
    label: i18n('entities.notification.fields.from'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'to',
    label: i18n('entities.notification.fields.to'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'relatedTo',
    label: i18n('entities.notification.fields.relatedTo'),
  },
  {
    name: 'relatedResources',
    label: i18n('entities.notification.fields.relatedResources'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'relatedAssets',
    label: i18n('entities.notification.fields.relatedAssets'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'relatedLocations',
    label: i18n('entities.notification.fields.relatedLocations'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.notification.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.notification.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
